import React from 'react'
import { Text } from 'react-native'
import i18n from 'i18n-js'

export default (T = ({ t = 'undefined', values, ...rest }) => {
  return <Text {...rest}>{i18n.t(t, values)}</Text>
})
